"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffPlatformShareDestinationTitle = exports.OffPlatformShareDestinationPlatform = void 0;
var OffPlatformShareDestinationPlatform;
(function (OffPlatformShareDestinationPlatform) {
    OffPlatformShareDestinationPlatform["COPY_LINK"] = "Copy Link";
    OffPlatformShareDestinationPlatform["SNAPCHAT"] = "Snapchat";
    OffPlatformShareDestinationPlatform["FACEBOOK"] = "Facebook";
    OffPlatformShareDestinationPlatform["MESSENGER"] = "Messenger";
    OffPlatformShareDestinationPlatform["TIKTOK"] = "TikTok";
    OffPlatformShareDestinationPlatform["INSTAGRAM"] = "Instagram";
    OffPlatformShareDestinationPlatform["PINTEREST"] = "Pinterest";
    OffPlatformShareDestinationPlatform["TWITTER"] = "Twitter";
    OffPlatformShareDestinationPlatform["WHATSAPP"] = "WhatsApp";
    OffPlatformShareDestinationPlatform["REDDIT"] = "Reddit";
    OffPlatformShareDestinationPlatform["EMAIL"] = "Email";
    OffPlatformShareDestinationPlatform["MORE"] = "More";
    OffPlatformShareDestinationPlatform["MESSAGES"] = "Messages";
    OffPlatformShareDestinationPlatform["EMBED"] = "Embed";
})(OffPlatformShareDestinationPlatform = exports.OffPlatformShareDestinationPlatform || (exports.OffPlatformShareDestinationPlatform = {}));
var OffPlatformShareDestinationTitle;
(function (OffPlatformShareDestinationTitle) {
    OffPlatformShareDestinationTitle["COPY_LINK"] = "Copy";
    OffPlatformShareDestinationTitle["COPIED_LINK"] = "Copied!";
})(OffPlatformShareDestinationTitle = exports.OffPlatformShareDestinationTitle || (exports.OffPlatformShareDestinationTitle = {}));
//# sourceMappingURL=offPlatformShareEnums.js.map